import React, { createContext, useContext, useState } from 'react';

import { IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

interface IFinancialWarningsContextValue {
  excessiveProceedsFromSalePeriods: Set<string>;
  setExcessiveProceedsFromSalePeriods: (periods: Set<string>) => void;
  ppeBalanceBeforeProceeds: IPeriodsTableRow | null;
  setPpeBalanceBeforeProceeds: (balance: IPeriodsTableRow | null) => void;
  excessiveLoanRepaymentPeriods: Set<string>;
  setExcessiveLoanRepaymentPeriods: (periods: Set<string>) => void;
  excessiveBorrowedFundsPeriods: Set<string>;
  setExcessiveBorrowedFundsPeriods: (periods: Set<string>) => void;
  intangibleAmortizationData: IPeriodsTableRow | null;
  setIntangibleAmortizationData: (data: IPeriodsTableRow | null) => void;
  ppeDepreciationData: IPeriodsTableRow | null;
  setPpeDepreciationData: (data: IPeriodsTableRow | null) => void;
}

const FinancialWarningsContext = createContext<IFinancialWarningsContextValue>({
  excessiveProceedsFromSalePeriods: new Set(),
  setExcessiveProceedsFromSalePeriods: () => {},
  ppeBalanceBeforeProceeds: null,
  setPpeBalanceBeforeProceeds: () => {},
  excessiveLoanRepaymentPeriods: new Set(),
  setExcessiveLoanRepaymentPeriods: () => {},
  excessiveBorrowedFundsPeriods: new Set(),
  setExcessiveBorrowedFundsPeriods: () => {},
  intangibleAmortizationData: null,
  setIntangibleAmortizationData: () => {},
  ppeDepreciationData: null,
  setPpeDepreciationData: () => {},
});

export const FinancialWarningsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [excessiveProceedsFromSalePeriods, setExcessiveProceedsFromSalePeriods] = useState<Set<string>>(new Set());
  const [ppeBalanceBeforeProceeds, setPpeBalanceBeforeProceeds] = useState<IPeriodsTableRow | null>(null);
  const [excessiveLoanRepaymentPeriods, setExcessiveLoanRepaymentPeriods] = useState<Set<string>>(new Set());
  const [excessiveBorrowedFundsPeriods, setExcessiveBorrowedFundsPeriods] = useState<Set<string>>(new Set());
  const [intangibleAmortizationData, setIntangibleAmortizationData] = useState<IPeriodsTableRow | null>(null);
  const [ppeDepreciationData, setPpeDepreciationData] = useState<IPeriodsTableRow | null>(null);

  return (
    <FinancialWarningsContext.Provider
      value={{
        excessiveProceedsFromSalePeriods,
        setExcessiveProceedsFromSalePeriods,
        ppeBalanceBeforeProceeds,
        setPpeBalanceBeforeProceeds,
        excessiveLoanRepaymentPeriods,
        setExcessiveLoanRepaymentPeriods,
        excessiveBorrowedFundsPeriods,
        setExcessiveBorrowedFundsPeriods,
        intangibleAmortizationData,
        setIntangibleAmortizationData,
        ppeDepreciationData,
        setPpeDepreciationData,
      }}
    >
      {children}
    </FinancialWarningsContext.Provider>
  );
};

export const useFinancialWarnings = () => useContext(FinancialWarningsContext);
